// This file is AUTOGENERATED, do not edit it manually!!!

export const koPeopleTemplates = {
    nomatch_text: 'Desculpe, nada foi encontrado',
    roles: 'Funções',
    teams: 'Equipes',
    users: 'Usuários',
};
